/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997ListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductSalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { ProductSalesfor1997Data, ProductSalesfor1997Service } from './ProductSalesfor1997.service';
import { ProductSalesfor1997SearchComponent }  from './ProductSalesfor1997Search.component';

@Component({
	selector: 'my-ProductSalesfor1997',
	template: require('./ProductSalesfor1997List.component.html'),
	providers: [ProductSalesfor1997Service],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductSalesfor1997ListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	ProductSalesfor1997List: ProductSalesfor1997Data[];
	newProductSalesfor1997: ProductSalesfor1997Data;
	selectedProductSalesfor1997: ProductSalesfor1997Data;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(ProductSalesfor1997SearchComponent) filterComponent: ProductSalesfor1997SearchComponent;

	sortExpression: string = "CategoryName";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private ProductSalesfor1997Service: ProductSalesfor1997Service,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newProductSalesfor1997 = new ProductSalesfor1997Data();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.ProductSalesfor1997Service.getAll().subscribe(record => this.ProductSalesfor1997List=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getProductSalesfor1997ByPaging();

		/*
		this.ProductSalesfor1997List = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getProductSalesfor1997() {
		this.ProductSalesfor1997Service.getAll()
			.subscribe(data => this.ProductSalesfor1997List = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on ProductSalesfor1997Search Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getProductSalesfor1997ByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getProductSalesfor1997ByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getProductSalesfor1997ByPaging();
	}
	
	// Get records by paging
	getProductSalesfor1997ByPaging() {
		this.ProductSalesfor1997Service.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.ProductSalesfor1997List=data.ProductSalesfor1997List;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addProductSalesfor1997() {
		this.ProductSalesfor1997Service.addProductSalesfor1997Data(this.newProductSalesfor1997).subscribe(record => console.log(record));
		this.getProductSalesfor1997();
	}
  
	// Updates existing record
	updateProductSalesfor1997() {
		this.ProductSalesfor1997Service.updateProductSalesfor1997Data(this.selectedProductSalesfor1997).subscribe(record => console.log(record));
		this.getProductSalesfor1997();
	}

	// Deletes record with specified id
	deleteProductSalesfor1997(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductSalesfor1997?') == true)
		{
			this.ProductSalesfor1997Service.deleteProductSalesfor1997(id)
			.subscribe(data => this.getProductSalesfor1997(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getProductSalesfor1997ByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getProductSalesfor1997ByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getProductSalesfor1997ByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getProductSalesfor1997ByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: ProductSalesfor1997Data) {
		this.router.navigate(['/ProductSalesfor1997', item.CategoryName]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: ProductSalesfor1997Data) {
		this.router.navigate(['/ProductSalesfor1997/Details', item.CategoryName]);
	}

	// Set record as selected
	SelectProductSalesfor1997(item: ProductSalesfor1997Data) {
		this.selectedProductSalesfor1997 = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: ProductSalesfor1997Data) {
		return item.CategoryName === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductSalesfor1997/ProductSalesfor1997List.component.ts